import React from "react";
// libs
import styled from "styled-components";
import { GetServerSideProps, NextPage } from "next";
import axios from "src/libs/axios";
// components
import CustomHead from "src/components/ui/CustomHead";
import Layout from "src/layout";
import ReviewsContainer from "src/components/containers/reviews/index";
// theme
import { colors } from "src/theme/colors";
// hooks
import { useDynamicCommonData } from "src/hooks/dynamic/common";
import useAllPage from "src/hooks/dynamic/allPage";
// types
import { EVariants } from "src/constants/variants";
import { TClinicDetails } from "src/types";
// const
import { ENDPOINTS } from "src/constants/endpoints";

const Wrapper = styled.div`
  background-color: ${colors.white};
`;

// type IUser = {
//   id: number
//   firstName: string
// }

interface IClinicPage {
  reviews: any;
  clinic: TClinicDetails;
  reviewsStatistic: any;
  reviewsCount: any;
}

const ReviewsPage: NextPage<IClinicPage> = (props) => {
  return (
    <>
      <CustomHead />

      <Wrapper>
        <Layout headerProps={{ variant: EVariants.SECONDARY, styles: { width: "1096px" } }}>
          <ReviewsContainer {...props} />
        </Layout>
      </Wrapper>
    </>
  );
};

const { GET } = ENDPOINTS;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const [clinicResponse, reviewsResponse, reviewsCountResponse, reviewsStatisticResponse] =
    await Promise.all([
      axios.get(`${GET.clinics}/${ctx.query.name}`),
      axios.get(`${GET.reviews}?clinic=${ctx.query.name}`),
      axios.get(`${GET.reviewsCount}?clinic=${ctx.query.name}`),
      axios.get(`${GET.reviewsStatistic}?clinic=${ctx.query.name}`),
    ]);
  const initialReduxState = await useAllPage(ctx.locale as string);

  return {
    props: {
      initialReduxState: { DYNAMIC: initialReduxState.DYNAMIC },
      clinic: clinicResponse.data,
      reviews: reviewsResponse.data,
      reviewsStatistic: reviewsStatisticResponse.data,
      reviewsCount: reviewsCountResponse.data,
    },
  };
};

export default ReviewsPage;
